<template>
  <section class="card">
    <h4 class="card__title">{{ name }} <span v-if="isDefault">(Por defecto)</span></h4>

    <div class="card__body">
      <label class="card__label">Empresa</label>
      <p class="card__text">{{ data.entity.name }}</p>
      <label class="card__label">Campaña</label>
      <p class="card__text">{{ data.name }}</p>
      <label class="card__label">Nombre de plantilla</label>
      <p class="card__text">{{ `${data.name}_${data.entity.name}_${type}` }}</p>
      <label class="card__label">N° de cabeceras</label>
      <p class="card__text">{{ headersCount }}</p>
    </div>

    <div class="card__actions">
      <a-button size="small" type="link" @click="handleEdit" :id="`edit-import-template-${type}`">
        Editar
      </a-button>
      <ReplicateTemplateModal :type="type" />
      <DownloadTemplateButton :type="type" />
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";

import ReplicateTemplateModal from "@/app/imports/components/modals/modalTemplates/ReplicateTemplateModal.vue";
import DownloadTemplateButton from "@/app/imports/components/buttons/DownloadTemplateButton.vue";

export default defineComponent({
  components: {
    ReplicateTemplateModal,
    DownloadTemplateButton,
  },
  props: {
    name: {
      required: true,
      type: String,
    },
    data: {
      required: true,
      type: Object,
    },
    type: {
      required: true,
      type: String,
      validator: (value) => ["contacts", "product"].includes(value),
    },
  },
  data() {
    return {
      downloadUrl: "",
    };
  },
  computed: {
    headersCount() {
      let arrayName = "account_template";
      if (this.type == "contacts") arrayName = "client_template";
      return this.data[`${arrayName}`]?.length || 0;
    },
    isDefault() {
      const count = this.type == "contacts" ? 1 : 2;
      return this.headersCount == count;
    },
  },
  async mounted() {
    this.downloadUrl = await this.$store.dispatch("downloadTemplateByType", this.type);
  },
  methods: {
    handleEdit() {
      this.$router.push(`/imports/templates/edit-${this.type}`);
    },
  },
});
</script>

<style lang="sass" scoped>
.card
  color: #151e28
  background-color: $gray-2
  border: $border-normal
  border-radius: 8px
  padding: 0 12px
  width: 100%
  min-width: 280px
  height: 340px
  display: flex
  flex-direction: column
  margin: 0 12px 12px 0

  &__title
    border-bottom: $border-normal
    text-align: center
    padding: 8px

  &__label
    font-weight: 600

    &::after
      content: ':'

  &__body
    flex: auto

  &__text
    margin-bottom: 8px

  &__actions
    border-top: $border-normal
    display: flex
    align-items: center
    justify-content: center
    padding: 4px
    height: 44px
</style>
